import React, { useEffect, useState } from 'react'
import { Col, Media, Row, Button, Nav, NavItem, NavLink } from 'reactstrap'
import { useHistory } from "react-router-dom";
import ReferCode from './ReferCode'
import { ToastContainer, toast } from "react-toastify"
import { Fade } from 'react-reveal'
import { checkKycStatus, getObUserState, getThirdPartyData, getUserPans, getUserReferalDetail } from '../services/waitlist-service'
import { mldInvest } from '../assets/constants/mld-invest';
import WorkFold from './WorkFold'
import MldFaq from './MldFaq'
import { OroLoaderInline } from '../../core'
import StateCardBasic from './StateCardBasic'
import pending from "../../waitlist/assets/images/pending.svg";
import { isMobile } from 'react-device-detect'
import { flatten, get } from "lodash";
import Sticky from "react-sticky-el";
import StatsFold from './StatsFold';
import { utils } from '../../core/helpers/utils';

function ReferDashboard() {
    const history = useHistory();

    const [referralsDetail, setReferralsDetail] = useState('');
    const [isUserApproved, updateUserApproved] = useState(false);
    const [loader, setLoader] = useState(false);
    const [allDocUploaded, setAllDocUploaded] = useState(false);
    const [errors, setErrors] = useState();
    const [activeTab, setActiveTab] = useState("Bonds");

    useEffect(() => {
        setLoader(true);
        determineIfKycApproved().then(obUserApprovedStatus => {
            if (obUserApprovedStatus && obUserApprovedStatus.obUserApproved) {
                getUserReferalDetail().then((result) => {
                    const response = utils.parsePayload(result);
                    if (response.data) {
                        setReferralsDetail(response.data);
                    }
                });
            }
        }).finally(() => setLoader(false));
    }, []);
    
    useEffect(()=>{
        getUserPans({ "X-product": `orobonds:default`, 'x-encrypted-data': true }).then((result) => {
            const response = utils.parsePayload(result);
            if (!response.success) {
                return toast.error("Something went wrong")
            }
            if (
              response &&
              response.success &&
              response.data &&
              response.data.length
            ) {
              setErrors([
                ...flatten(
                  get(response, "data", []).map((p) =>
                    p.rejectRemarks ? p.rejectRemarks : []
                  )
                ),
              ]);
            }
          });
    },[])

    function updateUserState(email, pan) {
        let product = "orobonds";
        return getObUserState({ email, pan}, product,
            { "X-product": `orobonds:default` })
            .then(result => {
                const response = utils.parsePayload(result);
                if (!response.success) {
                    toast.error(response.msg || response.message ||
                        "Something went wrong, unable to get user state details!");
                    return { obUserApproved: false };
                }
                if (response.results &&
                    response.results.obUserApproved) {
                    updateUserApproved(true);
                    return { obUserApproved: true };
                }
                return { obUserApproved: false };
            });
    }

    function updateUserDocStatus(email, pan, productName) {
        let product = "orobonds";
        return checkKycStatus(email, pan, { "X-product": `orobonds:${productName}` })
          .then(result => {
            const docStatusResp = utils.parsePayload(result);

            if (!docStatusResp || !docStatusResp.success) {
              toast.error("Something went wrong, unable to get kyc details!");
              return;
            }if(docStatusResp && docStatusResp.results){
                setAllDocUploaded(docStatusResp.results.allDocUploadedForThirdParty)
            }
          });
      }


    function determineIfKycApproved() {
        return getThirdPartyData(
            { "X-product": `orobonds:default`, 'x-encrypted-data': true }).then((result) => {
                const response = utils.parsePayload(result);
            if (!response.success) {
                toast.error(response.message || response.msg ||
                    "Unable to load TPD data");
                return { obUserApproved: false };
            } else {
                if (response.data && response.data.email && response.data.pan) {
                    let email = response.data.email;
                    let pan = response.data.pan;
                    updateUserDocStatus(email, pan, response.productName)
                    return updateUserState(email, pan);
                }
            }
        })
    }

    const redirect = () =>{
        history.push({
            pathname: "/biddeasy-docvault",
      });
    }

    const toggle = (tab) => {
        setActiveTab(tab);
    };

    const tabStyle = {
        border: {
            top: "1px solid #D9D9D9",
            left: "1px solid #D9D9D9",
            right: "1px solid #D9D9D9",
            bottom: "none"
        },
        color: "#283A97"
    }

    const getTabElement = (tab) => {
        switch (tab) {
          case "FD":
            return (
                <ReferCode 
                    referralsDetail={referralsDetail} 
                    isUserApproved={isUserApproved}
                    errors={errors}
                    allDocUploaded={allDocUploaded}
                    activeTab={activeTab}
                />
            );
          case "Bonds":
            return (
                <>
                <ReferCode 
                    referralsDetail={referralsDetail} 
                    isUserApproved={isUserApproved}
                    errors={errors}
                    allDocUploaded={allDocUploaded}
                    activeTab={activeTab}
                />
                </>
            )
          default:
            return <></>;
        }
      };

    return !loader ? 
    
        <>
        <div className='refer-navbar'>
            <div className='nav-inner'>
                <div className={"nav " + (activeTab === "FD" ? "activetab" : "")} onClick={() => toggle("FD")}>
                    FD referral
                </div>
                <div className={"nav " + (activeTab === "Bonds" ? "activetab" : "")} onClick={() => toggle("Bonds")}>
                    Bonds referral
                </div>
            </div>
        </div>
        <div className='mld-invest-ref'>
            <div style={isMobile ? {paddingTop: "2rem"} :{}}onClick={redirect}>
            {errors && errors.length ?
                <StateCardBasic
                    img={pending}
                    state="pending"
                    cta="Complete your KYC"
                    link="/biddeasy-docvault"
                    text1="Complete your KYC to be eligible to Refer."
                    text2="Click here to start now"
                /> : !allDocUploaded ? 
                <StateCardBasic
                    img={pending}
                    state="pending"
                    cta="Complete your KYC"
                    link="/biddeasy-docvault"
                    text1="Complete your KYC to be eligible to Refer."
                    text2="Click here to start now"
                />  : !isUserApproved ? 
                <StateCardBasic
                    img={pending}
                    state="pending"
                    cta="Complete your KYC"
                    link="/biddeasy-docvault"
                    text1="Thank you for sharing your details. We will review your KYC and get back to you."
                    // text2="here."
                /> 
                : null }
            </div>
            
            <div className="w-100">
                {getTabElement(activeTab)}
            </div>
            
            {/* <div className="w-100 stats-div">
                <Col xs={12} lg={12} className="text-center">
                    <div className="info-block">
                        <Fade bottom="bottom" distance="50px">
                            <p className="block-title">
                                {mldInvest.stats.title}
                            </p>
                        </Fade>
                    </div>
                </Col>
                <div className="stats-fold " style={{ maxWidth: "100%" }}>
                    {mldInvest.stats.statsItems.map((item) => (
                        <Col
                            lg={3}
                            sm={12}
                            xs={12}
                            md={6}
                            className="d-flex stats-col"
                        >
                            <Row className="stats-row">
                                <Media src={item.img} alt="stat-img" className="cards-img" />
                                <div className="d-flex content ">
                                    <p className="title">
                                        {item.title}
                                    </p>
                                    <p className="subtext font-size-small">
                                        {item.subtext}
                                    </p>
                                </div>
                            </Row>
                        </Col>
                    ))}
                </div>
            </div> */}
            <WorkFold />
            <StatsFold isMobile={isMobile}/>
            <MldFaq faqs={mldInvest.faqRefer} />
            <ToastContainer />
        </div> 
        </>
        : <OroLoaderInline />
    
}

export default ReferDashboard;